export interface ObjectPermissionSetType {
 objectPermissionSetTypeId: number;
 objectPermissionSetTypeName: string;
}

export interface BusinessObject {
 objectId: number;
 objectName: string;
 parentObjectId: number | null;
}

export interface ObjectPermission {
 objectPermissionId: number;
 objectPermissionName: string;
}

export interface ObjectPermissionSetData {
 objectPermissionSetId: number;
 objectId: number;
 objectPermissionId: number;
 objectPermissionValue: boolean;
 object: BusinessObject;
 objectPermission: ObjectPermission;
}

export interface ObjectPermissionTree {
 object: BusinessObject;
 permissions: ObjectPermissionSetData[];
 childrenObjectPermissions: ObjectPermissionTree[];
}

export interface ObjectPermissionSet {
 objectPermissionSetId: number;
 objectPermissionSetTypeId: number;
 entityId: number;
 objectPermissionSetType: ObjectPermissionSetType | null;
 objectPermissions: ObjectPermissionSetData[] | null;
 objectPermissionTree: ObjectPermissionTree | null;
}

export const emptyPermissionSet: ObjectPermissionSet = {
 objectPermissionSetId: -1,
 objectPermissionSetTypeId: -1,
 entityId: -1,
 objectPermissionSetType: null,
 objectPermissions: null,
 objectPermissionTree: null,
};

export enum BuilderPermissions {
 informations = 2,
 phoneNumber = 3,
 email = 4,
 location = 5,
 calendar = 6,
 website = 7,
 links = 8,
 aboutMe = 9,
 socialNetworks = 10,
 video = 11,
 galery = 14,
 testimonials = 17,
 customCtaButton = 23,
 appStores = 24,
 paymentOptions = 25,
 contactForm = 26,
 colourPicker = 31
}
